<template>
    <PreLoginView>
        <PreLoginForm title="CREATE_ACCOUNT">
            <SignupForm
                :errors="errors"
                :loading="loading"
                @submit="submit"
                v-if="region"
            />
        </PreLoginForm>
    </PreLoginView>
</template>
<script>
import SignupForm from './SignupForm.vue'
import PreLoginView from '@/views/PreLoginView/PreLoginView'
export default {
    components: {
        PreLoginView,
        SignupForm,
        PreLoginForm: () => import('@/views/PreLoginView/PreLoginForm')
    },
    data() {
        return {
            loading: false,
            errors: new this.$Errors(),
            popUp: false
        }
    },
    computed: {
        region() {
            return this.$route.query.region
        },
        formType() {
            return this.$route.query.type
        },
        queryMessage() {
            return this.$route.query.message
        }
    },
    methods: {
        capitalizeName(name) {
            return name.charAt(0).toUpperCase() + name.slice(1)
        },
        cleanMail(mail) {
            return mail.replace(/\s+/g, '').toLowerCase()
        },
        cleanPhone(phone) {
            return phone.toString().replace(/\D/g, '')
        },
        submit(payload) {
            const form = payload.form
            const formType = payload.type
            const region = this.$route.query.region
            if (this.loading || !region || !formType) {
                return
            }
            this.loading = true
            if (!this.$Utils.validateMail(form.mail)) {
                this.errors.set('mail')
                this.$Notif.error('INVALID_EMAIL_FORMAT')
                this.loading = false
                return
            }
            if (form.password != form.repeatPassword) {
                this.errors.set('password')
                this.errors.set('repeatPassword')
                this.$Notif.error('TOAST_PASSWORD_MATCH')
                this.loading = false
                return
            }
            if (!form.regulations || !form.privacy) {
                this.$Notif.error('TOAST_ACCEPT_LEGALS')
                this.loading = false
                return
            }
            this.createParent(form)
        },
        createParent(form) {
            const data = {
                name: this.capitalizeName(form.name),
                surname: this.capitalizeName(form.surname),
                mail: this.cleanMail(form.mail),
                password: form.password,
                phone: this.cleanPhone(form.phone)
            }
            this.$route.query.token
                ? this.createParentWithToken(data)
                : this.createParentWithoutToken(data)
        },
        createParentWithToken(data) {
            data.token = this.$route.query.token
            this.$api
                .post(`v1/qr`, data)
                .then(() => {
                    this.handleRegisteredParent(data)
                })
                .catch(error => {
                    this.$Network.handleError(error, this.errors)
                    this.loading = false
                })
        },
        createParentWithoutToken(data) {
            this.$api
                .post(`v1/accounts`, data)
                .then(() => {
                    this.$router.push('/status/signup_success')
                })
                .catch(error => {
                    this.$Network.handleError(error, this.errors)
                })
                .then(() => {
                    this.loading = false
                })
        },
        handleRegisteredParent(data) {
            const timeout = this.$Utils.isMobileDevice() ? 1500 : 0
            switch (this.$Utils.mobileDeviceType()) {
                case 'android':
                    window.location =
                        'https://play.google.com/store/apps/details?id=com.livekidmobileadmin'
                    break
                case 'ios':
                    window.location =
                        'market://details?id=com.livekidmobileadmin&hl=pl'
                    break
            }
            setTimeout(() => {
                this.loginUser(data)
            }, timeout)
        },
        loginUser(creds) {
            const { mail, password } = creds
            const dataToSend = {
                mail,
                password
            }
            this.$api
                .post('v1/accounts/login', dataToSend)
                .then(({ data }) => {
                    this.routeUserToMainApp(data)
                })
                .catch(error => {
                    this.$Network.handleError(error, this.errors)
                })
                .then(() => {
                    this.loading = false
                })
        },
        routeUserToMainApp(userData) {
            const jwt = userData.roles[0].jwt
            const lang = this.$i18n.locale
            window.location = `${this.$env.getMainApp()}?jwt=${jwt}&lang=${lang}&region=${
                this.region
            }`
        }
    }
}
</script>
